import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '@/components/home'
import snapsuite from '@/components/snapsuite'
import about from '@/components/about'
import fashionforchange from '@/components/fashionforchange'
import veganambition from '@/components/veganambition'
import glide from '@/components/glide'
import cluep from '@/components/cluep'
import login from '@/components/login'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/snapsuite',
    name: 'snapsuite',
    component: snapsuite
  },
  {
    path: '/about',
    name: 'about',
    component: about
  },
  {
    path: '/fashionforchange',
    name: 'fashionforchange',
    component: fashionforchange
  },
  {
    path: '/veganambition',
    name: 'veganambition',
    component: veganambition
  },
  {
    path: '/glide',
    name: 'glide',
    component: glide
  },
  {
    path: '/cluep',
    name: 'cluep',
    component: cluep
  },
  {
    path: '/login',
    name: 'login',
    component: login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js